import {bootstrapApplication} from '@angular/platform-browser';
import {registerWebawesomeIcons} from 'angular-components';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';

registerWebawesomeIcons();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
